import { AuthError } from '@azure/msal-browser';

/**
 * A session that cannot be used, raised by this app rather than by MSAL.
 *
 * A plain `Error` was indistinguishable from a bug at the point where it had to
 * be told apart from one: neither is an `ApiError` — `api/errors.ts` passes an
 * error with no HTTP response through untouched on purpose — so the `_auth`
 * loader rethrew both and the router rendered its raw fallback for a session
 * that had merely expired. Subclassing rather than wrapping keeps `message`
 * untouched, so nothing that reads it has to change.
 */
export class SessionError extends Error {}

/**
 * Is this a failure of the session rather than of the app?
 *
 * Everything MSAL rejects with derives from `AuthError`, `BrowserAuthError`
 * (`timed_out` from a blocked or unreachable renewal iframe,
 * `interaction_in_progress`, `no_network_connectivity`) and
 * `InteractionRequiredAuthError` included — so the base class is the whole test.
 */
export function isSessionFailure(err: unknown): boolean {
  return err instanceof SessionError || err instanceof AuthError;
}
